import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./AccountAds.module.scss";
import classNames from "classnames/bind";
import { createAxios } from "../../../createInstance";
import { loginSuccess } from "../../../redux/authSlice";
import {
    loginActAdsFb
} from "../../../redux/apiRequest";
import ToastMessage, { showToast } from "../../../Components/ToastMessage";

const cx = classNames.bind(styles);

const AccountAds = () => {
    const navigate = useNavigate();

    const actAdses = [
        {
            _id: "123465",
            img: "adsad",
            actname: "Hồ Ngọc Thiện",
        },
    ]

    const handleAddFB = () => {
        window.FB.login(
            function (response) {
                if (response.authResponse) {
                    handleResponseFacebook(response.authResponse);
                } else {
                    alert("Người dùng đã huỷ đăng nhập hoặc từ chối.");
                }
            },
            {
                scope:
                    "email,ads_read,pages_show_list,pages_read_engagement",
            }
        );
    };
    const handleResponseFacebook = async (authData) => {
        try {
            const result = await loginActAdsFb(authData.accessToken);
            if (result) {
                showToast({
                    type: "success",
                    title: "Thành công!",
                    message: "Bạn đã liên kết tài khoản FB Ads thành công",
                    duration: 3000
                })
            } else {
                showToast({
                    type: "warning",
                    title: "Cảnh báo!",
                    message: "Bạn không có quyền truy cập tài khoản này!",
                    duration: 3000
                })
            }
        } catch (error) {
            // const data = error?.response?.data;
            showToast({
                type: "error",
                title: "Cảnh báo!",
                message: "Liên kết tài khoản thất bại, vui lòng thử lại!",
                duration: 3000
            })
        }
    };

    const handleAddTiktok = () => {
    };

    useEffect(() => {
    }, []);

    return (
        <main className={cx("main")}>
            <div className={cx("header")}>
                <h1 className={cx("title")}>Facebook Account Ads</h1>
                <button className={cx("add-button")} onClick={handleAddFB}>
                    Add
                </button>
            </div>
            <div className={cx("actAds-list")}>
                {actAdses.map((actAds) => (
                    <div
                        key={actAds._id}
                        className={cx("actAds-card")}
                        onClick={() => navigate(`/account-ads/${actAds._id}`)}
                    >
                        <img src={actAds.img} alt={actAds.actname} className={cx("actAds-logo")} />
                        <span className={cx("actAds-name")}>{actAds.actname}</span>
                        <div className={cx("card-actions")}>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                className={cx("delete-button")}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            <div className={cx("header", "header2")}>
                <h1 className={cx("title")}>TikTok Account Ads</h1>
                <button className={cx("add-button")} onClick={handleAddTiktok}>
                    Add
                </button>
            </div>
            <div className={cx("actAds-list")}>
                {actAdses.map((actAds) => (
                    <div
                        key={actAds._id}
                        className={cx("actAds-card")}
                    >
                        <img src={actAds.img} alt={actAds.actname} className={cx("actAds-logo")} />
                        <span className={cx("actAds-name")}>{actAds.actname}</span>
                        <div className={cx("card-actions")}>
                            {/* <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                className={cx("edit-button")}
                            >
                                Edit
                            </button> */}
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                className={cx("delete-button")}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            <ToastMessage />
        </main>
    );
};

export default AccountAds;
